<template lang="pug">
.order__item
  .order__full
    .order-wrapper(style="")
      .order__item__left
        .order__item__title.h2-title {{$t('common.order')}} №{{ order.code }}

        .order__item__expired
          span.text {{ dateFormatted(order.created_at) }}

        template
          .img-wrapper(v-if="order.tickets && order.tickets.length" :style="{ 'background-image': `url(${(order.tickets[0].performance.images && order.tickets[0].performance.images.length) ? order.tickets[0].performance.images[0]['original'] : require('@/assets/img/noImage.jpg')}`}")
          .img-wrapper(v-if="order.services && order.services.length" :style="{ 'background-image': `url(${(order.services[0].service.performance.images && order.services[0].service.performance.images.length) ? order.services[0].service.performance.images[0]['original'] : require('@/assets/img/noImage.jpg')})`}")
          .img-wrapper(v-if="order.items && order.items.length" :style="{ 'background-image': `url(${(order.items[0].images && order.items[0].images.length) ? order.items[0].images[0]['original'] : require('@/assets/img/noImage.jpg')})`}")
            // picture(:style="{ 'background-image': `url(${order.tickets ? order.tickets[0].performance.image['original'] : ''})`}")
            // img(:src="order.tickets ? order.tickets[0].performance.image['original'] : ''" alt="")
        // .order__floor
          .order__floor__items
            ticket-icon(v-for="type in order._types", :type="type")
              | {{type}}
          .info-text(v-if="tab == 'used'")
            p(v-if="order.status == 1") {{$t('msgs.noActiveTicket')}}
          info-text(v-else)
            tempalte(v-if="order.awaitingСonfirm")
              p {{$t('awaitConfirm')}}
            template(v-else-if="order.status == 1")
              p(v-if="order.isFromExternal")
                | {{$t('msgs.externalTicket')}}
              template(v-else-if="order['_types'][0] !== 'trains'")
                // p(v-if="order.hasObjectInfokiok")
                //   | {{$t('msgs.printYourself')}}
                // p(v-if="!order.hasObjectInfokiok")
                //   | {{$t('msgs.printTickets')}}
                p(v-if="order.hasObjectWallet == 1")
                  | {{$t('msgs.printTickets')}}
                p(v-if="order.hasObjectWallet == 0")
                  | {{$t('enterPrint')}}
              p(v-else-if="order.options.remoteCheckIn")
                | На некоторые билеты доступна электронная регистрация
              p(v-else)
                | Билеты необходимо получить в кассах Белорусской железной дороги
            template(v-else-if="order.status == 3")
              p {{$t('msgs.returnProccess')}}
            template(v-else-if="order.status == 0")
              p {{$t('msgs.needPayment')}}

        .order__footer(v-if="!order.awaitingСonfirm")
          arc-button(v-if="order.hasVideo", :name="$t('common.myVideos')",
          @click="toVideos()", outline)
          // arc-button(:name="$t('common.details')", @click="more()", outline-gray)
          arc-button(v-if="order.status == 0", :name="$t('common.toPayment')",
          @click="toPayment()", outline-gray)
          arc-button(v-if="order.status == 1 && !order.hasObjectInfokiok && !order.isFromExternal && tab !== 'used'",
          :name="$t('common.print')", @click="action(order.id, 'print')", outline-gray)
          arc-button(v-if="order.status == 1 && !order.hasObjectInfokiok && !order.isFromExternal && tab !== 'used'",
          :name="$t('common.download')", @click="action(order.id, 'download')", outline-gray)
          // arc-drop-button(:name="$t('common.more')", top, :list="moreButtons", @action="doAction",
            outline-gray)
          arc-button(v-if="order.status == 0",:name="`${$t('cancel')}`", @click="doAction({action: 'cancel'})", outline-gray)
      // .order__item__separator
      .order__item__right
        .row(style="margin-bottom: 18px;")
          tag(
            :danger="order.status === 4 || order.status === 99 ",
            :warning="order.status === 3 || order.status === 0",
            :success="order.status === 1 && tab !== 'used'",
            :awaiting="order.status === 0 && order.awaitingСonfirm",
          )
            span {{ tab == 'used' ? $t('common.used') : statusText(order.status) }}
        .order__item__price.h2-title(v-show="order.amount_int > 0")
          | {{ order.total_amount }} {{ getLayout.currency_symbol ? getLayout.currency_symbol : $t('currency.rub') }}
        //- .order__item__price-clean(v-show="order.total_amount_int > 0")
        //-   | {{$t('common.price')}}: {{ order.amount }} руб.
        .order__item__price-clean(v-show="order.discount > 0")
          | {{$t('common.discount')}}: {{ order.discount | price('.') }} {{ getLayout.currency_symbol ? getLayout.currency_symbol : $t('currency.rub') }}
        .order__item__price-commission(v-show="order.commission > 0")
          | {{$t('common.commission')}}: {{ order.commission | price('.') }} {{ getLayout.currency_symbol ? getLayout.currency_symbol : $t('currency.rub') }}

        qr-code-vue(v-if="order.tickets && order.tickets.length && order.tickets.length == 1" :value="order.tickets[0].qr" :size="isMobile ? 100 : 130" level="H")
        qr-code-vue(v-if="order.services && order.services.length && order.services.length == 1" :value="order.services[0].qr" :size="isMobile ? 100 : 130" level="H")
        qr-code-vue(v-if="order.items && order.items.length && order.items.length == 1 && !order.tickets.length && !order.services.length" :value="order.items[0].qr || order.items[0].code" :size="isMobile ? 100 : 130" level="H")
        arc-button.returnHover(style="color: #FF0000;padding:1px 6px;margin-top: 18px;", v-if="order.status == 1 && tab !== 'used' && !(order._types && order._types.length == 1 && order._types[0] == 'items')",:name="`${$t('returnOrder')}`", @click="doAction({action: 'return'})", outline-gray)
        // .return-order(v-if="order.status == 1 && tab !== 'used'", @click="doAction({action: 'return'})") {{ $t('returnOrder') }}
  .order__dedicate(:class="{'opened': open}")
    template(v-for="(ticket, index) in order.tickets")
      ticket(:ticket="ticket", :orderId="order.id", :tab="tab", :ticketIndex="index", @update="update()")

    template(v-for="train in order.trains")
      train(:ticket="train", :orderId="order.id", :isUsed="tab == 'used'",
        :noOp="order.status === 3", @update="update()")

    template(v-for="transfer in order.transfers")
      transfer(:ticket="transfer", :orderId="order.id", :isUsed="tab == 'used'",
        :noOp="order.status === 3", @update="update()")

    template(v-for="(item, index) in order.items")
      item(:item="item", :itemIndex="index", :orderId="order.id", @update="update()")

  popup-cancel(v-if="showCancel", :orderId="order.id", @close="showCancel = false",
    @onCancel="update()")

  popup-return(v-if="showReturn", :orderId="order.id", @close="showReturn = false",
    @onReturn="update()")

  popup-er(v-if="removeEReg",
    :orderId="order.id",
    :type="'order'",
    :status="0",
    @close="removeEReg = false",
    @onCancel="update()")

  popup-er(v-if="addEReg",
    :orderId="order.id",
    :type="'order'",
    :status="1",
    @close="addEReg = false",
    @onCancel="update()")

  .yellow-wide-line

</template>

<script>
import { mapGetters } from 'vuex';
import cfg from '@/api/config';
import API from '@/api/api';

import popupCancel from '@/components/popups/cancel.vue';
import popupReturn from '@/components/popups/return.vue';
import popupEr from '@/components/popups/EReg.vue';
import ka from 'moment/locale/ka';
import QrCodeVue from 'qrcode.vue';
import TicketIcon from './icon/icon';
import TicketIconBig from './icon/big-icon';

import Tag from './tag';

import Ticket from './part/ticket';
import Train from './part/train';
import Transfer from './part/transfer';
import Item from './part/item';

export default {
  name: 'OrderView',
  props: {
    order: {
      type: Object,
      default: () => (null),
      required: false,
    },
    tab: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    moreButtons: [],
    open: false,
    showReturn: false,
    showCancel: false,
    addEReg: false,
    removeEReg: false,
    isMobile: false,
  }),
  mounted() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
    }
    console.log('ORDER', this.order);
    this.makeMore();
    this.more();
  },
  computed: {
    ...mapGetters({
      getLayout: 'getLayout',
    }),
    cabinet() {
      if (this.$store.state.cabinet) {
        return this.$store.state.cabinet;
      }
      return null;
    },
  },
  methods: {
    update() {
      this.$emit('update');
      this.showCancel = false;
      this.showReturn = false;
      this.addEReg = false;
      this.removeEReg = false;
    },
    makeMore() {
      if (this.order.status === 1 && !this.order.hasObjectInfokiok && !this.order.isFromExternal) {
        this.moreButtons.push({
          action: 'download',
          name: this.$t('common.download'),
        });
      }
      if (this.order.status !== 3 && !this.order.isFromExternal) {
        const currentDate = new Date();
        const timestamp = Math.floor(currentDate.getTime() / 1000);
        if (this.order.status === 1 && this.tab !== 'used' && timestamp < this.order.expired_ad) {
          this.moreButtons.push({
            action: 'return',
            name: 'Возврат всех билетов заказа',
          });
        }
        if (this.order.status === 0 && !this.order.isFromExternal) {
          this.moreButtons.push({
            action: 'cancel',
            name: 'Отмена',
          });
        }
        if (this.order.options.remoteCheckInAvailable && this.order.options.remoteCheckIn) {
          this.moreButtons.push({
            action: 'remoteCheckOut',
            name: 'Отменить электронную регистрацию для всего заказа',
          });
        }
        if (this.order.options.remoteCheckInAvailable && !this.order.options.remoteCheckIn) {
          this.moreButtons.push({
            action: 'remoteCheckIn',
            name: 'Электронная регистрация для всего заказа',
          });
        }
        // eslint-disable-next-line no-underscore-dangle
        if (this.order._types[0] === 'trains') {
          this.moreButtons.push({
            action: 'receipt',
            name: 'Чек оплаты',
          });
        }
        if (this.order.options.receiptReturn) {
          this.moreButtons.push({
            action: 'receipt-return',
            name: 'Чек возврата',
          });
        }
      }
    },
    doAction({ name = undefined, action = undefined }) {
      global.console.log(name, action);
      if (action === 'cancel') {
        this.showCancel = true;
      } else if (action === 'return') {
        this.showReturn = true;
      } else if (action === 'remoteCheckIn') {
        this.addEReg = true;
      } else if (action === 'remoteCheckOut') {
        this.removeEReg = true;
      } else if (action === 'receipt' || action === 'receipt-return') {
        this.doReceipt(this.order.id, action);
      } else if (action) {
        this.action(this.order.id, action);
      }
    },
    toPayment() {
      this.$router.push({ name: 'payment', params: { id: this.order.id } });
    },
    toVideos() {
      this.$router.push({ name: 'videos' });
    },
    statusText(status) {
      switch (status) {
        case 0:
          if (this.order.awaitingСonfirm) {
            return 'ожидает подтверждения';
          }
          return this.$t('msgs.statusWait');
        case 1:
          return this.$t('msgs.statusPayed');
        case 2:
          return this.$t('msgs.statusReturned');
        case 3:
          return this.$t('msgs.statusReturnWait');
        case 4:
          return this.$t('msgs.statusExpired');
        default:
          return this.$t('msgs.statusProblems');
      }
    },

    action(id, key, prefix = 'api/v2') {
      const { cabinet: { profile: { downloadToken = undefined } = {} } = {} } = this;
      if (id <= 0 || !downloadToken) {
        return;
      }
      window.open(`${cfg.baseUrl}/${prefix}/users/me/orders/${id}/${key}?t=${downloadToken}`);
    },

    doReceipt(id, key) {
      const { cabinet: { profile: { downloadToken = undefined } = {} } = {} } = this;
      if (id <= 0 || !downloadToken) {
        return;
      }
      if (key === 'receipt') {
        window.open(`${cfg.baseUrl}/api/v3/order/${id}/receipt?t=${downloadToken}`);
      } else if (key === 'receipt-return') {
        window.open(`${cfg.baseUrl}/api/v3/order/${id}/receipt?t=${downloadToken}&returned=1`);
      }
    },

    async more() {
      if (this.open) {
        this.open = false;
        return;
      }
      const data = await API.getOrder(this.order.id, (localStorage.getItem('lang') ? localStorage.getItem('lang') : 'ru'));
      if (data) {
        this.order.tickets = data.tickets;
        this.order.trains = data.trains;
        this.order.transfers = data.transfers;
        this.order.items = data.items;
        this.order.services = data.services;
        this.open = true;
      }
      // global.console.log('more', order);
    },
    dateFormatted(date) {
      let utc = 3;
      if (window && window.location.href.match(/guru.ge/)) {
        utc = 4;
      }
      const unixConverted = this.$moment(date).unix() + utc * 3600;
      let locale = localStorage.getItem('lang');
      if (!locale) locale = 'ru';
      if (locale && locale != 'ge') { // eslint-disable-line
        return this.$moment(unixConverted * 1000).locale(locale).format('DD MMM YYYY, HH:mm');
      }
      return this.$moment(unixConverted * 1000).locale('ka', ka).format('DD MMM YYYY, HH:mm');
    },
  },
  components: {
    Tag,
    Ticket,
    TicketIcon,
    TicketIconBig,
    Train,
    Transfer,
    popupCancel,
    popupReturn,
    popupEr,
    Item,
    QrCodeVue,
  },
};
</script>

<style lang="scss">
.order {
  &__full {
    position: relative;
    // display: flex;
    // flex-direction: row;
    // justify-content: flex-start;
    // align-items: stretch;
    // min-height: 278px;
    // height: 278px;
    background-color: rgb(255, 255, 255);
    z-index: 2;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1),
              5px 5px 10px rgba(0, 0, 0, 0.1),
              10px 10px 20px rgba(0, 0, 0, 0.1);
  }
  &__item {
    @media screen and (min-width: 960px) {
      width: 75%;
      box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1),
              5px 5px 10px rgba(0, 0, 0, 0.1),
              10px 10px 20px rgba(0, 0, 0, 0.1);
    }

    @media screen and (max-width: 960px) {
      width: 100%;
    }

    // box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
    // background: linear-gradient(135deg, #e0e0e0, #fff);
    // box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);

    // border-radius: 10px;
    // border: solid 1px rgb(229, 229, 229);
    // border: 2px solid black;
    background-color: rgb(255, 255, 255);
    overflow: hidden;
    &__expired {
      display: flex;
      flex-direction: row;
      margin-top: 18px;
      margin-bottom: 18px;
    }
    &__price {
      font-size: 18px;
      margin-bottom: 18px;
      &-clean, &-commission {
        font-family: Inter;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: rgb(0, 0, 0);
      }
      &-clean {
        margin-bottom: 10px;
      }
      &-commission {
        margin-bottom: 17px;
      }
    }
    &__left {
      width: 60%;
      padding: 0 35px;
      border-right: 2px dashed lightgray;
      height: 85%;
      // border-top: 2px solid black;
      // border-bottom: 2px solid black;
    }
    &__separator {
      height: 100%;
      min-width: 1px;
      max-width: 1px;
      width: 1px;
      // background-color: rgb(240, 240, 240);

      // width: 200px;
      // height: 100px;
      background-color: #999;
      background-image: url("data:image/svg+xml;utf8,<svg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill: none; stroke: red; stroke-width: 4; stroke-dasharray: 5 20'/></svg>");
    }
    &__right {
      width: 40%;
      padding: 0 35px;
      height: 85%;
      // border-right: 2px solid black;
      // border-top: 2px solid black;
      // border-bottom: 2px solid black;
    }
    &__title {
      font-size: 18px;
    }
  }
  &__floor {
    max-height: 100px;
    min-height: 100px;
    height: 100px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 27px;
    &__items {
      display: flex;
    }
    &__items > * {
      margin: 0 5px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    .info-text {
      margin-left: 30px;
      height: 44px;

      display: inline-flex;
      flex-direction: column;
      /* justify-content: flex-start; */
      align-items: center;
      p {
        width: 100%;
        padding-bottom: .5rem;
      }
    }
  }
  &__footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    > * {
      margin: 0 12px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    @media screen and (max-width:960px) {
      gap:.75rem;
    }
  }

  &__dedicate {
    // border-top: 1px solid rgb(229, 229, 229);
    // transition: height 1s ease-in-out;
    // overflow: auto;
    // height: 90px;
    // margin-top: -100%;

    -webkit-transition: all .25s ease-in-out;
    transition: all .25s ease-in-out;
    max-height: 0;

    &.opened{
      max-height: 3000px;
    }
  }
}

.img-wrapper {
  // height: 170px;
  // width: 300px;
  aspect-ratio: 16 / 9;
  width: 100%;
  margin-bottom:18px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media screen and (max-width: 960px){
    width: 100%;
    aspect-ratio: 16 / 9;
    height: unset;
  }
}

.order-wrapper {
  display:flex;
  padding: 35px 0 35px 0;
  @media screen and (max-width: 960px) {
    padding: 15px 0 15px 0;
  }
}

</style>
